export const URLS = {
  AUTH_SHOPPING_CART: 'supplyOmni/shoppingCart',
  AUTH_PRODUCT_SCAN: 'supplyOmni/productScan',
  AUTH_SELECT_CLIENT: 'supplyOmni/shoppingCartSelectClient',
  AUTH_SCAN_RECEIPT: 'supplyOmni/scanReceipt/:id',
  AUTH_CLIENT_DETAILS: 'supplyOmni/shoppingCartClientDetails/:id',
  AUTH_PROFORMA_VIEW: 'supplyOmni/proformaView/:id',
  AUTH_RECEIPT_INVOICE: 'supplyOmni/receiptInvoiceFinalized',
  AUTH_RECEIPT_CLIENT: 'supplyOmni/receiptClientDetails/:id',
  AUTH_RECEIPT_SELECT_CLIENT: 'supplyOmni/receiptSelectClient',
  AUTH_PROFORMA_LIST: 'supplyOmni/proformaList',
  AUTH_MY_SALES: 'supplyOmni/sales',
  AUTH_BILLS_TABLES: 'supplyOmni/bills',
  AUTH_BILL: 'supplyOmni/bills/:id'
}

export const LEGAL_PERSON_TYPE = 'B2B'
